import { BaseModel } from "@/store/feathers/feathers.client.js";

// import MailRenderMjml from 'scripts/mail-template-render-mjml'

export default class NotificationTemplates extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "NotificationTemplates";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {

    return {

      name: null,
      subject: null,
      preheader: null,
      description: null,
      kind: null,
      type: null,
      layout: [],

      page: {
        background_color: '#E8E8E8',
        background_url: null,
        background_repeat: 'no-repeat',
        background_size: 'cover',
        background_position: 'center center',
        padding_top: 0,
        padding_bottom: 0,
      },

      container: {
        elevated: false,
        border_color: "#333333",
        border_width: 0,
        border_style: "solid",
        width: 650,
        breakpoint: 480,
        color: "#333333",
        background_color: "#fafafa",
        font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
      },

      header: {
        enabled: true,
        enable_links: true,
        height: 100,
        background: "#fafafa",
        color: "#333333",
        background_url: null,
        padding_top: 20,
        image_url: "https://i.imgur.com/elraLKs.png",
        image_link: "https://i.imgur.com/elraLKs.png",
        image_alt: "logo",
        image_width: 300,
        image_height: 60,
        link1_url: null,
        link1_name: "Link 1",
        link2_url: null,
        link2_name: "Link 2",
        link3_url: null,
        link3_name: "Link 3",
      },

      hero: {
        enabled: true,
        background: '#333333',
        background_url: 'https://i.imgur.com/gElfZr8.jpg',

        title_font_size: 24,
        title_font_weight: 'normal',
        title_font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
        title_color: '#333333',
        title_padding_top: 20,
        title_padding_bottom: 20,
        title: 'Call To Action Title',

        subtitle_font_size: 16,
        subtitle_font_weight: 'normal',
        subtitle_font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
        subtitle_color: '#333333',
        subtitle_padding_top: 10,
        subtitle_padding_bottom: 10,
        subtitle: 'Call to Action subtitle',

        button_background: '#333333',
        button_color: '#fafafa',
        button_font_size: 16,
        button_font_weight: 'normal',
        button_font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',

        button_border_radius: 24,
        button_border_style: 'none',
        button_border_width: 1,
        button_border_color: 'red',

        button_link: null,
        button_padding_bottom: 10,
        button_padding_top: 10,
        button_padding_x: 20,
        button_padding_y: 10,
        button_title: 'Click Me'
      },

      title: {
        enabled: true,
        background: "#333333",
        color: "#fafafa",
        padding_bottom: 20,
        padding_top: 20,
        html: `<div style="text-align: center;"><span style="font-size: x-large;"><b>Title Section</b></span></div>`
      },

      content: {
        enabled: true,
        background: "#fafafa",
        color: "#333333",
        padding_bottom: 20,
        padding_top: 20,
        html: `<b style="font-size: medium;">Hello&nbsp;\${customer.dba_name},</b><div style="font-size: medium;">
        <br></div><div style="font-size: medium;"><span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id mi lobortis, egestas tellus non, viverra neque. Proin placerat, 
        ligula quis vestibulum pretium, metus ex ornare neque, at maximus nibh ligula sed neque.&nbsp;</span></div>
        <div style="font-size: medium;"><span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;">
        <br></span></div><div style=""><span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;"><i style="">
        <font size="2">Nulla quis vulputate ex, ac euismod nunc. Integer id dapibus odio. Morbi eget imperdiet velit, eu euismod mauris. Suspendisse tempor pulvinar ligula, 
        nec ullamcorper erat faucibus vitae.</font></i><font size="3">&nbsp;</font></span></div><div style="font-size: medium;">
        <span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;"><br></span></div><div style="font-size: medium;">
        <span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;">Vestibulum ullamcorper nec quam sed efficitur. Pellentesque id nisi imperdiet, 
        lacinia elit non, rutrum lectus. Nullam et dui massa. Etiam sit amet sem sed libero pharetra tristique a ultrices purus. Integer sit amet molestie tellus. 
        Sed lectus lorem, imperdiet sed malesuada eu, consectetur eget ipsum. Mauris et ex mollis, ultrices turpis et, vestibulum justo. Praesent vitae scelerisque turpis.
        </span></div><div style="font-size: medium;"><span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;">
        <br></span></div><div style="text-align: center;"><span style="font-family: &quot;Open Sans&quot;, Arial, sans-serif; text-align: justify;">
        <font size="4"><b>Click the button below to sign up:</b></font></span></div>`
      },

      button: {
        enabled: true,
        background: '#fafafa',

        button_background: '#333333',
        button_color: '#fafafa',
        button_font_size: 24,
        button_font_weight: 'normal',
        button_font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',

        button_border_radius: 4,
        button_border_style: 'none',
        button_border_width: 1,
        button_border_color: 'red',

        button_link: null,
        button_padding_bottom: 10,
        button_padding_top: 10,
        button_padding_x: 40,
        button_padding_y: 10,
        button_title: 'Click Me'
      },

      closing: {
        enabled: true,
        background: "#fafafa",
        color: "#333333",
        padding_bottom: 20,
        padding_top: 20,
        html: `<div style="text-align: center;">If you have any questions or comments please don't hesitate to contact us.</div><div style="text-align: center;">
        <br></div><div style="text-align: center;"><br></div><div>
        \${merchant.dba_name}<br></div><div>\${merchant.phone}&nbsp\${merchant.phone_extension}<br></div><div>\${merchant.website}<br></div>`
      },

      brand: {
        enabled: true,
        background: "#333333",
        padding_top: 20,
        padding_bottom: 20,
        logo_url: null,
        logo_width: 120,
        logo_link: null,
        logo_padding_top: 0,
        logo_padding_bottom: 0,

        tagline: "We are the best!",
        tagline_padding_top: 5,
        tagline_padding_bottom: 20,
        tagline_font_size: 16,
        tagline_font_weight: 'normal',
        tagline_font_style: 'normal',
        tagline_font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
        tagline_color: "#fafafa",

        contact_font_weight: 'normal',
        contact_padding_bottom: 5,
        contact_font_size: 12,
        contact_font_style: 'normal',
        contact_font_family: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
        contact_color: "#fafafa",

        contact_address1: null,
        contact_address2: null,
        contact_phone: null,
        contact_website: null,
        contact_email: null,

        social_enabled: true,
        social_blog_enabled: true,
        social_github_enabled: true,
        social_instagram_enabled: true,
        social_youtube_enabled: true,
        social_facebook_enabled: true,
        social_google_enabled: true,
        social_twitter_enabled: true,
        social_pinterest_enabled: true,
        social_linkedin_enabled: true,
        social_vimeo_enabled: true,
        social_medium_enabled: true,
        social_soundcloud_enabled: true,
        social_dribble_enabled: true,
        social_tumblr_enabled: true,
        social_xing_enabled: true,

        social_blog: null,
        social_github: null,
        social_instagram: null,
        social_youtube: null,
        social_facebook: null,
        social_google: null,
        social_twitter: null,
        social_pinterest: null,
        social_linkedin: null,
        social_vimeo: null,
        social_medium: null,
        social_soundcloud: null,
        social_dribble: null,
        social_xing: null,

      },
      footer: {
        enabled: true,
        background: "#333333",
        color: "#fafafa",
        padding_bottom: 20,
        padding_top: 20,
        html: `<div style="text-align: center; padding-left:40px; padding-right:40px"><font size="1">You are receiving this email 
        because you opted in on our website, at an event, puchased goods or services from us or becuase you are a friend of \${merchant.dna_name}.</font></div>`,
      },
      promo: null,
      mjml: null,
      html: null,
      json: null,
      mid_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }


  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {


    return data;
  }
}


